// src/store/store.js
import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk"; // Pastikan lokasi ini benar
import rootReducer from "../reducers"; // Pastikan lokasi ini benar
import authMiddleware from "../middleware/authMiddleware"; // Pastikan lokasi ini benar

const store = createStore(rootReducer, applyMiddleware(thunk, authMiddleware));

export default store;
